<template>
  <div id="financeTop">
    <div class="title">
      <img src="../../assets/image/icon_liuc@2x.png" style="width:34px" alt />
      <h3>我的流程</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="clientActive" @tab-click="handleClick">
        <!-- 1项目待办 -->
        <el-tab-pane label="项目待办" name="1">
          <span slot="label" v-if="waitnumber1>0">
            <span class="span-box">
              <el-badge :value="waitnumber1" :max="99" class="item">
                <span>{{ '项目待办' }}</span>
              </el-badge>
            </span>
          </span>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 5%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='1'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button
                :class="projectDoWait ? 'changBtn1':'changBtn'"
                @click="handleProjectWiatChange"
              >
                <span v-if="projectDoWait">切换到已办</span>
                <span v-if="!projectDoWait">切换到待办</span>
              </el-button>
              <el-button @click="handleSearch1" class="search">查询</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目信息</div>
                <div class="headerItem" style="width:13%;text-align:center">项目阶段</div>
                <div class="headerItem" style="width:20%;text-align:center">创建时间</div>
                <div class="headerItem" style="width:13%;text-align:center">创建人</div>
                <div class="headerItem" style="width:24%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="upcomingList.length>0">
                <li
                  class="tableBodyItem"
                  v-for="item in upcomingList"
                  :key="item.id"
                  @click="goProjectDetails(item)"
                >
                  <div class="bodyItem" style="width:30%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.project_name}}</h3>
                    <p style="color:#999; display:flex;">
                      <span>企业名称:</span>
                      <span
                        :title="item.company_name"
                        class="companyNameOverFlow"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </p>
                    <p style="color:#999;">
                      <span>项目类型:</span>
                      <span
                        :title="item.project_type_show"
                        style="color:#666"
                      >{{item.project_type_show}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p
                      :title="item.project_status_show"
                      class="tableItemContent"
                    >{{item.project_status_show}}</p>
                    <p
                      class="tableItemContent"
                      v-if="item.stage_code=='12'"
                      style="color:#FF3333"
                    >待接受</p>
                    <p
                      class="tableItemContent"
                      v-else-if="item.stage_code=='120' || item.stage_code=='121'"
                      style="color:#FF3333"
                    >待分配</p>
                    <p style="color:#128bf1" class="tableItemContent" v-else-if="!projectDoWait">已办</p>
                    <p class="tableItemContent" v-else style="color:#FF3333">待审批</p>
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.padd_time}}</p>
                  </div>
                  <div
                    class="bodyItem"
                    style="width:13%;padding-left:5px;padding-right:0;text-align:center;"
                  >
                    <p style="text-align:center;">{{item.memberInfo.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:24%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow" v-if="!projectDoWait">
                      <el-button class="Corss">查看详情</el-button>
                    </div>
                    <div v-else>
                      <div
                        class="tableBtnRow"
                        v-if="item.stage_code=='120' || item.stage_code=='121'"
                      >
                        <el-button class="Corss" @click.stop="goProjectDetailsBack(item)">分配</el-button>
                      </div>
                      <div class="tableBtnRow" v-else-if="item.stage_code=='12'">
                        <el-button class="Corss" @click.stop="goProjectDetails(item)">接受</el-button>
                        <el-button class="GetBack" @click.stop="goProjectDetails(item)">拒绝</el-button>
                      </div>
                      <div class="tableBtnRow" v-else>
                        <el-button @click.stop="handlePass(item)" class="Corss">通过</el-button>
                        <el-button @click.stop="handleReject(item)" class="GetBack">驳回</el-button>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow" v-if="upcomingList.length>0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 2项目待阅 -->
        <el-tab-pane label="项目待阅" name="2">
          <span slot="label" v-if="waitnumber2>0">
            <span class="span-box">
              <el-badge :value="waitnumber2" :max="99" class="item">
                <span>{{ '项目待阅' }}</span>
              </el-badge>
            </span>
          </span>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input v-model="searchInfo1" placeholder="项目名称"></el-input>
              <el-date-picker
                v-model="searchDate1"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 5%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='2'" @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button
                :class="projectReadWait ? 'changBtn1':'changBtn'"
                @click="handleProjectReadChange"
              >
                <span v-if="projectReadWait">切换到已阅</span>
                <span v-if="!projectReadWait">切换到待阅</span>
              </el-button>
              <el-button @click="handleSearch2" class="search">查询</el-button>
            </div>
          </div>
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目信息</div>
                <div class="headerItem" style="width:13%;text-align:center">项目阶段</div>
                <div class="headerItem" style="width:20%;text-align:center">创建时间</div>
                <div class="headerItem" style="width:13%;text-align:center">创建人</div>
                <div class="headerItem" style="width:24%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="readList.length>0">
                <li class="tableBodyItem" v-for="item in readList" :key="item.id">
                  <div class="bodyItem" style="width:30%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.project_name}}</h3>
                    <p style="color:#999; display:flex;">
                      <span>企业名称:</span>
                      <span
                        :title="item.company_name"
                        class="companyNameOverFlow"
                        style="color:#666"
                      >{{item.company_name}}</span>
                    </p>
                    <p style="color:#999;">
                      <span>项目类型:</span>
                      <span
                        :title="item.project_type_show"
                        style="color:#666"
                      >{{item.project_type_show}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p
                      :title="item.project_status_show"
                      class="tableItemContent"
                    >{{item.project_status_show}}</p>
                    <!-- <p class="tableItemContent" style="color:#FF3333">待审批</p> -->
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.padd_time}}</p>
                  </div>
                  <div
                    class="bodyItem"
                    style="width:13%;padding-left:5px;padding-right:0;text-align:center;"
                  >
                    <p
                      style="text-align:center;"
                      v-if="item.memberInfo"
                    >{{item.memberInfo.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:24%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button
                        style="margin-left:10px"
                        v-if="projectReadWait"
                        @click="handleProjectRead(item)"
                        class="check"
                      >查看详情</el-button>
                    </div>
                    <div class="tableBtnRow">
                      <el-button
                        style="margin-left:10px"
                        @click="handleProjectReaded(item)"
                        v-if="!projectReadWait"
                        class="check"
                      >查看详情</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow" v-if="readList.length>0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 3财务待办 -->
        <el-tab-pane label="财务待办" name="3">
          <span slot="label" v-if="waitnumber3>0">
            <span class="span-box">
              <el-badge :value="waitnumber3" :max="99" class="item">
                <span>{{ '财务待办' }}</span>
              </el-badge>
            </span>
          </span>
          <!-- 按钮行 -->
          <div class="btnRow btnRowWithDate">
            <div class="left" style="width:70%">
              <el-input @change="searchInputNameChange" v-model="searchInfo1" placeholder="模糊查询"></el-input>
              <el-date-picker
                v-model="searchDate1"
                type="date"
                @change="searchData1Change"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin-right:2%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                @change="searchData2Change"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>

              <one-selected v-if="clientActive=='3'" @my-one-change="handleSearchPeopleChangeVuex"></one-selected>
              <el-select
                v-model="searchStage_code"
                @change="searchStageCodeChange"
                clearable
                placeholder="申请类型"
              >
                <el-option
                  v-for="item in caiwuTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div class="right">
              <el-button
                :class="finaceDoWait ? 'changBtn1':'changBtn'"
                @click="handleFinnaceWiatChange"
              >
                <span v-if="finaceDoWait">切换到已办</span>
                <span v-if="!finaceDoWait">切换到待办</span>
              </el-button>
              <el-button @click="handleSearch3" class="search">查询</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目信息</div>
                <div class="headerItem" style="width:13%;text-align:center">项目阶段</div>
                <div class="headerItem" style="width:20%;text-align:center">创建时间</div>
                <div class="headerItem" style="width:13%;text-align:center">创建人</div>
                <div class="headerItem" style="width:24%;text-align:center">操作</div>
              </div>
              <ul
                class="table__body"
                v-if="$store.state.process.myFlow.finnaceUpcomingList.length>0"
              >
                <li
                  @click="checkFinnaceDetails(item)"
                  class="tableBodyItem"
                  v-for="item in $store.state.process.myFlow.finnaceUpcomingList"
                  :key="item.id"
                >
                  <div class="bodyItem" style="width:30%">
                    <el-tooltip class="item" effect="light" :content="item.title" placement="top">
                      <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3>
                    </el-tooltip>
                    <p style="color:#999;">
                      <span>申请类型:</span>
                      <span
                        :title="item.project_status_show"
                        style="color:#666"
                      >{{item.project_status_show}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p
                      :title="item.project_status_show"
                      class="tableItemContent"
                    >{{item.project_status_show}}</p>
                    <p
                      class="tableItemContent"
                      v-if="item.stage_code=='12'"
                      style="color:#FF3333"
                    >待接受</p>
                    <p
                      class="tableItemContent"
                      v-else-if="item.stage_code=='120' || item.stage_code=='121'"
                      style="color:#FF3333"
                    >待分配</p>
                    <p style="color:#128bf1" class="tableItemContent" v-else-if="!finaceDoWait">已办</p>
                    <p class="tableItemContent" v-else style="color:#FF3333">待审批</p>
                    <p
                      class="tableItemContent"
                      v-if="item.project_status_show=='报告用章审批'"
                      style="color:#666"
                    >{{item.top_content}}</p>
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.padd_time}}</p>
                  </div>
                  <div
                    class="bodyItem"
                    style="width:13%;padding-left:5px;padding-right:0;text-align:center;"
                  >
                    <p
                      style="text-align:center;"
                      v-if="item.memberInfo"
                    >{{item.memberInfo.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:24%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow" v-if="item.stage_code=='120' ||item.stage_code=='121'">
                      <el-button class="Corss">分配</el-button>
                    </div>
                    <div class="tableBtnRow" v-else-if="item.stage_code=='12'">
                      <el-button class="Corss">接受</el-button>
                      <el-button class="GetBack">拒绝</el-button>
                    </div>
                    <div class="tableBtnRow" v-else>
                      <el-button v-if="finaceDoWait" @click.stop="handlePass(item)" class="Corss">通过</el-button>
                      <el-button
                        v-if="finaceDoWait"
                        @click.stop="handleReject(item)"
                        class="GetBack"
                      >驳回</el-button>
                      <el-button v-if="!finaceDoWait" class="Corss">查看详情</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow" v-if="$store.state.process.myFlow.finnaceUpcomingList.length>0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="$store.state.process.myFlow.finnaceUpcomingListTotal"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 4财务待阅 -->
        <el-tab-pane label="财务待阅" name="4">
          <span slot="label" v-if="waitnumber4>0">
            <span class="span-box">
              <el-badge :value="waitnumber4" :max="99" class="item">
                <span>{{ '财务待阅' }}</span>
              </el-badge>
            </span>
          </span>
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <!-- <el-input v-model="searchInfo1" placeholder="项目名称"></el-input> -->
              <el-date-picker
                v-model="searchDate1"
                type="date"
                style="margin-right:0"
                placeholder="开始时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsStart"
              ></el-date-picker>

              <span style="line-height:48px;margin:0 5%;color:#666">至</span>
              <el-date-picker
                v-model="searchDate2"
                type="date"
                placeholder="结束时间"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptionsEnd"
              ></el-date-picker>
              <one-selected v-if="clientActive=='4'" @my-one-change="handleSearchPeopleChange"></one-selected>
              <!-- <el-select v-model="searchStage_code" clearable placeholder="申请类型">
                <el-option
                  v-for="item in caiwuTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>-->
            </div>
            <div class="right">
              <el-button
                :class="finaceReadWait ? 'changBtn1':'changBtn'"
                @click="handleFinnaceReadChange"
              >
                <span v-if="finaceReadWait">切换到已阅</span>
                <span v-if="!finaceReadWait">切换到待阅</span>
              </el-button>
              <el-button @click="handleSearch4" class="search">查询</el-button>
            </div>
          </div>
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:30%">项目信息</div>
                <div class="headerItem" style="width:13%;text-align:center">项目阶段</div>
                <div class="headerItem" style="width:20%;text-align:center">创建时间</div>
                <div class="headerItem" style="width:13%;text-align:center">创建人</div>
                <div class="headerItem" style="width:24%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="finnaceReadList.length>0">
                <li class="tableBodyItem" v-for="item in finnaceReadList" :key="item.id">
                  <div class="bodyItem" style="width:30%">
                    <el-tooltip class="item" effect="light" :content="item.title" placement="top">
                      <h3 class="knowledgeTitle overflowDoit">{{item.title}}</h3>
                    </el-tooltip>
                    <p style="color:#999;">
                      <span>申请类型:</span>
                      <span
                        :title="item.project_status_show"
                        style="color:#666"
                      >{{item.project_status_show}}</span>
                    </p>
                  </div>
                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <p
                      :title="item.project_status_show"
                      class="tableItemContent"
                    >{{item.project_status_show}}</p>
                    <!-- <p
                      class="tableItemContent"
                      v-if="item.stage_code=='12'"
                      style="color:#FF3333"
                    >待接受</p>
                    <p
                      class="tableItemContent"
                      v-else-if="item.stage_code=='120'"
                      style="color:#FF3333"
                    >待分配</p>
                    <p class="tableItemContent" v-else style="color:#FF3333">待审批</p>-->
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.padd_time}}</p>
                  </div>
                  <div
                    class="bodyItem"
                    style="width:13%;padding-left:5px;padding-right:0;text-align:center;"
                  >
                    <p
                      style="text-align:center;"
                      v-if="item.memberInfo"
                    >{{item.memberInfo.nickname}}</p>
                  </div>
                  <div class="bodyItem" style="width:24%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button
                        style="margin-left:10px"
                        v-if="finaceReadWait"
                        @click="handleCheckFinnace(item)"
                        class="check"
                      >查看详情</el-button>
                      <el-button
                        style="margin-left:10px"
                        v-if="!finaceReadWait"
                        @click="checkReadedDetailsFinance(item)"
                        class="check"
                      >查看详情</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow" v-if="finnaceReadList.length>0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <!-- 5新成员申请 -->
        <el-tab-pane label="新成员申请" name="5">
          <span slot="label" v-if="waitnumber5>0">
            <span class="span-box">
              <el-badge :value="waitnumber5" :max="99" class="item">
                <span>{{ '新成员申请' }}</span>
              </el-badge>
            </span>
          </span>
          <!-- 表格行 -->
          <div class="financeTable financeTableNoInp">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:19%">申请人</div>
                <div class="headerItem" style="width:19%;text-align:center">备注</div>
                <div class="headerItem" style="width:19%;text-align:center">申请时间</div>
                <div class="headerItem" style="width:19%;text-align:center">申请方式</div>
                <div class="headerItem" style="width:24%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="memberList.length>0">
                <li class="tableBodyItem" v-for="item in memberList" :key="item.id">
                  <div class="bodyItem" style="width:19%">
                    <h3 class="knowledgeTitle overflowDoit">
                      <p v-if="item.member_show" style="color:#333;">{{item.member_show.nickname}}</p>
                      <p v-if="item.member_show" style="color:#666;">{{item.member_show.username}}</p>
                    </h3>
                  </div>
                  <div class="bodyItem" style="width:19%;padding-right:0;text-align:center;">
                    <p class="tableItemContent" v-if="item.remark">{{item.remark}}</p>
                    <p class="tableItemContent" v-else>{{'---'}}</p>
                  </div>
                  <div class="bodyItem" style="width:19%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.add_time}}</p>
                  </div>
                  <div
                    class="bodyItem"
                    style="width:19%;padding-left:5px;padding-right:0;text-align:center;"
                  >
                    <p style="text-align:center;">{{item.type_show}}</p>
                  </div>
                  <div class="bodyItem" style="width:24%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <div class="btnRRwo" v-if="item.status=='0'">
                        <el-button @click.stop="handlePassUser(item.id)" class="Corss">通过</el-button>
                        <el-button @click.stop="handleRejectUser(item.id)" class="GetBack">驳回</el-button>
                      </div>
                      <div v-if="item.status=='1'" style="color:rgb(48, 173, 95)">申请通过</div>
                      <div v-if="item.status=='-1'" style="color:rgb(245, 95, 95)">驳回</div>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow" v-if="memberList.length>0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 弹窗--通过审批 -->
    <el-dialog
      class="passDia"
      :visible.sync="passDialogVisible"
      width="45%"
      :before-close="handlePassClose"
      @close="handlePassClosed"
      v-dialogDrag
    >
      <div class="diaContainer">
        <p class="passTitle">确定审批通过吗</p>
        <el-input class="passInput" type="textarea" placeholder="请输入审批意见" v-model="passReason"></el-input>
        <p class="passTitle">签字</p>
        <p style="width:100%;display: flex;justify-content: center;margin-bottom:20px;">
          <img
            v-if="!sign_pic"
            @click="handleReceiverFlag"
            style="width:120px;height:120px;"
            src="../../assets/image/zaixianqianm@2x.png"
            alt
          />
          <img
            v-if="sign_pic"
            @click="handleReceiverFlag(sign_pic)"
            style="width:120px;height:120px;"
            :src="sign_pic"
            alt
          />
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="passDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="disableLimit" @click="passSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗-驳回 -->
    <el-dialog
      class="passDia"
      :visible.sync="rejectDialogVisible"
      width="45%"
      :before-close="handleRejectClose"
      @close="handleRejectClosed"
      v-dialogDrag
    >
      <div class="diaContainer">
        <p class="passTitle">确定驳回吗</p>
        <el-input class="passInput" type="textarea" placeholder="请输入审批意见" v-model="rejectReason"></el-input>
        <p class="passTitle">签字</p>
        <p style="width:100%;display: flex;justify-content: center;margin-bottom:20px;">
          <img
            v-if="!sign_pic"
            @click="handleReceiverFlag"
            style="width:120px;height:120px;"
            src="../../assets/image/zaixianqianm@2x.png"
            alt
          />
          <img
            v-if="sign_pic"
            @click="handleReceiverFlag(sign_pic)"
            style="width:120px;height:120px;"
            :src="sign_pic"
            alt
          />
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="disableLimit" @click="rejectSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗--新成员通过审批 -->
    <el-dialog
      class="passDia"
      :visible.sync="passUserDialogVisible"
      width="35%"
      :before-close="handleUserPassClose"
      @close="handleUserPassClosed"
      v-dialogDrag
    >
      <div class="diaContainer">
        <p class="passTitle">确定同意新成员加入吗</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="passUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="disableLimit" @click="handlePassUserSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 弹窗-新成员驳回 -->
    <el-dialog
      class="passDia"
      :visible.sync="rejectUserDialogVisible"
      width="35%"
      :before-close="handleUserRejectClose"
      @close="handleUserRejectClosed"
      v-dialogDrag
    >
      <div class="diaContainer">
        <p class="passTitle">确定驳回新成员申请吗</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="rejectUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="disableLimit" @click="handleRejectUserSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗(财务详情) -->
    <!-- 弹窗--业务 -->
    <el-dialog
      :visible.sync="dialogVisibleFinnace"
      width="60%"
      class="addClientDia"
      :before-close="handleCloseFinnace"
      @close="handleClosedFinnace"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age" v-if="showFormMyFlow==='showFormYwHandle'">业务详情</span>
      </div>
      <div class="diaContainer yauto" style="padding-top:20px;">
        <!-- 12.业务详情 -->
        <el-form
          ref="form"
          :model="addYwForm"
          v-if="showFormMyFlow==='showFormYwHandle'"
          label-position="left"
          label-width="150px"
        >
          <div class="diaForm_box diaEditFormBox">
            <div class="ShowFormBtn" v-if="!readDisable">
              <!-- <el-button
                :disabled="disableLimit"
                @click="handleFinnaceApproval('-1')"
                class="search"
              >驳回</el-button>
              <el-button
                class="creat"
                :disabled="disableLimit"
                @click="handleFinnaceApproval('1')"
                style="background-color:#40A0F2;"
              >通过</el-button>-->

              <!-- <el-button
                v-if="addYwForm.withdraw_status=='1'"
                @click="handleFinnaceWithDraw('bproject',addYwForm.id)"
                class="withdrap"
                style="background-color:rgb(255, 26, 26);"
              >撤回</el-button>-->
              <el-button
                v-if="addYwForm.is_just=='1'"
                @click="handleFinnaceApproveWithDraw('bproject',addYwForm.id)"
                :disabled="disableLimit"
                class="withdrap"
                style="background-color:rgb(255, 26, 26);"
              >审批撤回</el-button>
              <el-button
                @click="approveVisible=true"
                v-if="addYwForm.approval_status=='1'"
                class="creat"
                style="background-color:#40A0F2;"
              >去审批</el-button>
            </div>

            <!-- <el-form-item label="驳回节点" v-if="!isCheck && !readDisable">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addYwForm.stage_select"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>-->
            <!-- <el-form-item label="审批备注" v-if="!isCheck && !readDisable">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                class="finnaceRemarkApproval"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item label="签名" v-if="!isCheck && !readDisable" style="margin-bottom:20px">
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>-->
            <div class="diaFormTitle">业务信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 申请人 -->
              <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addYwForm.member">
                <span
                  v-if="addYwForm.member"
                  style="color:#666;font-size:16px"
                >{{addYwForm.member.nickname}}</span>
              </el-form-item>
              <!-- 项目名称 -->
              <el-form-item label="项目名称">
                <span style="color:#666;font-size:16px">{{addYwForm.project_name}}</span>
              </el-form-item>
              <!-- 登记时间 -->
              <el-form-item label="登记时间" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{addYwForm.record_time}}</span>
              </el-form-item>
              <!-- 金额 -->
              <el-form-item label="申请原因" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{addYwForm.total}}</span>
              </el-form-item>
              <el-form-item label="附件" style="margin-bottom:10px">
                <upload-file
                  :isSubmit="false"
                  :imgList="this.imgList"
                  :detailsImgList="detailsImgList"
                  @my-upload-change="upLoadChange"
                ></upload-file>
              </el-form-item>
            </div>
          </div>
          <div class="diaForm_box diaEditFormBox">
            <div class="diaFormTitle">审批信息</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 已通过 -->
              <el-timeline>
                <el-timeline-item v-for="(activity, index) in addYwForm.approval_log" :key="index">
                  <div style="margin-bottom:5px">
                    <span>提交人:</span>
                    <span>{{activity.memberInfo.nickname}}</span>
                    <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                    <span>{{activity.add_time}}</span>
                  </div>
                  <div>
                    <span
                      v-if="activity.approval_status=='1'"
                      style="margin-right:10px"
                    >{{activity.executorInfo.nickname}}</span>
                    <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                    <span
                      v-if="activity.approval_status=='-1'"
                      style="margin-right:10px"
                    >{{activity.executorInfo.nickname}}</span>
                    <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                    <span
                      v-if="activity.approval_status=='0'"
                      v-for="item in activity.tomemberInfo"
                      style="margin-right:10px"
                    >{{item.nickname+' '}}</span>
                    <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                    <span
                      style="margin-left:10px"
                      v-if="activity.update_time"
                    >{{activity.update_time}}</span>
                  </div>
                  <div class="remark" style="margin-top:5px" v-if="activity.remark">
                    <span style="margin-right:5px">备注:</span>
                    <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                  </div>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 弹窗--财务 -->
    <el-dialog
      :visible.sync="$store.state.process.finance.dialogVisible"
      width="60%"
      class="addClientDia"
      :before-close="handleCloseFinnaceFinance"
      @close="handleClosedFinnaceFinance"
      :modal-append-to-body="false"
      append-to-body
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age" v-if="showFormMyFlow==='showFormHandle'">报销详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormReportbHandle'">事前报备详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormClearHandle'">项目结算申请详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormZhuanHandle'">项目专家申请费详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormEndHandle'">到账记录详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormBusinessHandle'">业务结算申请详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormContractHandle'">合同登记详情</span>
      </div>
      <finance-details />
    </el-dialog>
    <!-- 弹窗--行政 -->
    <el-dialog
      :visible.sync="$store.state.process.admin.dialogVisible"
      width="60%"
      class="addClientDia"
      :before-close="handleCloseFinnaceAdmin"
      @close="handleClosedFinnaceAdmin"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age" v-if="showFormMyFlow==='showFormSendHandle'">邮寄详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormReportHandle'">报告用章审批详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormOtherHandle'">其他用章审批详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormHtHandle'">合同用章详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormHtSaveHandle'">合同存档详情</span>
        <span class="title-age" v-if="showFormMyFlow==='showFormExtrenalHandle'">外部用章详情</span>
      </div>
      <admin-details />
    </el-dialog>
    <!-- 签名组件 -->
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>

    <!-- 弹窗--去审批(业务详情用) -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia addClientDia1"
      :before-close="approveVisibleClose"
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addYwForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addYwForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addYwForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addYwForm.stage_select"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addYwForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addYwForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1')"
          :disabled="disableLimit"
          style="background:#f4a029;"
          v-if="addYwForm.approval_status=='1'"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1')"
          :disabled="disableLimit"
          v-if="addYwForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;margin-left:5%"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from 'echarts'
import OneSelected from '../../components/OneSelected'
import UploadFile from '../../components/UploadFile'
import TableJson from '../../components/TableJson'
import SignDialog from '../../components/SignDialog'

import AdminDetails from '../../components/finance/AdminDetails'
import FinanceDetails from '../../components/finance/FinanceDetails'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      approveVisible: false,
      is_chase: '0',
      k_code: '',
      approvalRemark: '',
      sign_pic: '',

      disableLimit: false,
      receiverSignFlag: false,

      searchStage_code: '',
      caiwuTypeList: [
        {
          name: '报销',
          value: 'reimbursement',
        },
        {
          name: '项目结算申请',
          value: 'settlement',
        },
        {
          name: '项目专家费申请',
          value: 'expert',
        },
        {
          name: '到账记录',
          value: 'arrival',
        },
        {
          name: '业务结算申请',
          value: 'business',
        },
        {
          name: '合同登记',
          value: 'contract',
        },
        {
          name: '邮寄',
          value: 'mail',
        },
        {
          name: '报告用章审批',
          value: 'report',
        },
        {
          name: '其他用章审批',
          value: 'chapter',
        },
        {
          name: '合同存档',
          value: 'contract_archive',
        },
        {
          name: '外部用章',
          value: 'external_seal',
        },
      ],
      activities: [
        {
          content: '活动按期开始',
          timestamp: '2018-04-15',
        },
        {
          content: '通过审核',
          timestamp: '2018-04-13',
        },
        {
          content: '创建成功',
          timestamp: '2018-04-11',
        },
      ],
      checkFinnaceId: '',
      dialogVisibleFinnace: false,
      addReimbursementForm: {},
      addSettlementForm: {},
      addExpertForm: {},
      addArrivalForm: {},
      addContractForm: {},
      addBusinessForm: {},
      addHtForm: {},
      addHtSaveForm: {},
      addYwForm: {},
      // 外部用章
      formData: {},

      waitnumber1: 0,
      waitnumber2: 0,
      waitnumber3: 0,
      waitnumber4: 0,
      waitnumber5: 0,
      addSendForm: {},
      addReportForm: {},
      addOtherForm: {},
      detailsImgList: [],
      editUserId: '',
      editPassId: '',
      passReason: '',
      rejectReason: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      // 弹窗
      imgDia: false,
      imgList: [],
      checkOutImgIndex: '',
      IsCloseShow: [],
      // 弹窗
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      passDialogVisible: false,
      passUserDialogVisible: false,
      rejectDialogVisible: false,
      rejectUserDialogVisible: false,
      upcomingList: [],
      readList: [],
      memberList: [],
      showFormMyFlow: '',
      clientActive: '1',
      tableData: [],
      finnaceUpcomingList: [],
      finnaceReadList: [],
      finance_id: '',
      stage_code: '',
      selectProjectNum: '',
      finnaceActive: '',
      projectList: [],
      projectList1: [],
      imgList: [],
      isCheck: false,
      readDisable: false,
      imgSize: '100%',
      searchUserId: '',
      searchInfo1: '',
      searchDate1: '',
      searchDate2: '',
      finaceDoWait: true,
      finaceReadWait: true,
      projectDoWait: true,
      projectReadWait: true,
      // 合同登记弹窗相关

      tableData: [],
      dialogVisibleAdd: false,
      diaFormType: 'add',
      AddMoneyForm: {
        name: '',
        money: '',
        return_money: '',
      },
      editTableIndex: '',
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchDate2) {
            return (
              time.getTime() > new Date(this.searchDate2).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchDate1) {
            return (
              time.getTime() <
                new Date(this.searchDate1).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
    }
  },
  components: {
    OneSelected,
    UploadFile,
    TableJson,
    SignDialog,
    AdminDetails,
    FinanceDetails,
  },
  watch: {
    'addContractForm.is_bid': {
      handler: function (val, oldVal) {
        if (val == '0') {
          this.addContractForm.bid_money = 0
        }
      },
    },
    'addContractForm.is_mark': {
      handler: function (val, oldVal) {
        if (val == '0') {
          this.tableData = []
        }
      },
    },
  },
  methods: {
    // 签字
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},
    handleProjectReadChange() {
      this.projectReadWait = !this.projectReadWait
      if (this.projectReadWait) {
        this.getread_list()
      } else {
        this.getread_list_wait()
      }
    },
    handleFinnaceReadChange() {
      this.finaceReadWait = !this.finaceReadWait
      if (this.finaceReadWait) {
        this.get_finnace_read_list()
      } else {
        this.get_finnace_read_wait_list()
      }
    },
    handleProjectWiatChange() {
      this.projectDoWait = !this.projectDoWait
      if (this.projectDoWait) {
        this.getupcoming_list()
      } else {
        this.getupWait_list()
      }
    },
    handleFinnaceWiatChange() {
      this.finaceDoWait = !this.finaceDoWait
      if (this.finaceDoWait) {
        this.get_finnace_coming_list()
      } else {
        this.get_finnace_wait_list()
      }
    },
    upLoadChange(data) {
      this.imgList = data
    },
    handleSearch1() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      this.currentPage = 1
      if (this.projectDoWait) {
        this.getupcoming_list()
      } else {
        this.getupWait_list()
      }
    },
    handleSearch2() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      this.currentPage = 1
      if (this.projectReadWait) {
        this.getread_list()
      } else {
        this.getread_list_wait()
      }
    },
    handleSearch3() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', 1)
      // this.currentPage = 1
      if (this.finaceDoWait) {
        this.get_finnace_coming_list()
      } else {
        this.get_finnace_wait_list()
      }
    },
    handleSearch4() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      this.currentPage = 1
      if (this.finaceReadWait) {
        this.get_finnace_read_list()
      } else {
        this.get_finnace_read_wait_list()
      }
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.searchUserId = data
    },
    handleSearchPeopleChangeVuex(data) {
      this.$store.commit('process/myFlow/setSearchPeople', data)
    },
    searchInputNameChange(val) {
      this.$store.commit('process/myFlow/setSearchInfo', val)
    },
    searchStageCodeChange(val) {
      this.$store.commit('process/myFlow/setSearchStagecode', val)
    },
    // 搜索栏信息改变存储到vuex
    searchData1Change(val) {
      this.$store.commit('process/myFlow/setSearchDate1', val)
    },
    searchData2Change(val) {
      this.$store.commit('process/myFlow/setSearchDate2', val)
    },
    checkReadedDetailsFinance(item) {
      this.readDisable = true
      this.checkFinnaceDetails(item)
    },
    checkFinnaceDetails(item) {
      console.log('item.project_status_show', item.project_status_show)
      // 财务编号
      this.finance_id = item.project_id
      // 项目类型编号
      this.stage_code = item.stage_code

      this.isCheck = false
      if (item.stage_code == 'reimbursement') {
        this.finnaceActive = 2
        this.handleCheckReimbursement(item.project_id)
      } else if (item.stage_code == 'settlement') {
        this.finnaceActive = 3
        this.handleCheckSettlement(item.project_id)
      } else if (item.stage_code == 'expert') {
        this.finnaceActive = 4
        this.handleCheckExpert(item.project_id)
      } else if (item.stage_code == 'arrival') {
        this.finnaceActive = 5
        this.handleCheckArrival(item.project_id)
      } else if (item.stage_code == 'reportb') {
        this.finnaceActive = 9
        this.handleCheckReportb(item.project_id)
      } else if (item.stage_code == 'business') {
        this.finnaceActive = 6
        this.handleCheckBusiness(item.project_id)
      } else if (item.stage_code == 'contract') {
        this.finnaceActive = 7
        this.handleCheckContract(item.project_id)
      } else if (item.stage_code == 'mail') {
        this.finnaceActive = 8
        this.handleCheckSend(item.project_id)
      } else if (item.stage_code == 'report') {
        this.finnaceActive = 9
        this.handleCheckReport(item.project_id)
      } else if (item.stage_code == 'chapter') {
        this.finnaceActive = 10
        this.handleCheckOther(item.project_id)
      } else if (item.stage_code == 'contract_seal') {
        this.finnaceActive = 11
        this.handleCheckHt(item.project_id)
      } else if (item.stage_code == 'bproject') {
        this.finnaceActive = 12
        this.handleCheckYw(item.project_id)
      } else if (item.stage_code == 'contract_archive') {
        this.finnaceActive = 13
        this.handleCheckHtSave(item.project_id)
      } else if (item.stage_code == 'external_seal') {
        this.finnaceActive = 14
        this.handleCheckExtrenal(item.project_id)
      }
    },
    async handleCheckFinnace(item) {
      this.readDisable = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      // param.append('read_id', item.id)
      param.append('finance_id', item.project_id)
      param.append('stage_code', item.stage_code)

      param.append('approval_status', '1')
      // param.append('remark', this.approvalRemark)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/set_fread',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.checkFinnaceDetails(item)
      this.get_finnace_read_list()
      this.getNumerData()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.get_finnace_coming_list()
      this.getNumerData()

      this.dialogVisibleFinnace = false
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', this.finance_id)
      param.append('stage_code', this.stage_code)

      param.append('approval_status', val)
      param.append('is_chase', this.is_chase)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      this.dialogVisibleFinnace = false
      this.approveVisible = false
      this.get_finnace_coming_list()
      this.getNumerData()
    },
    // ***获取预设审批人
    async get_preset_by_stage_code(stage_code) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/get_preset_by_stage_code',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$store.commit('process/admin/setList3', res.datas.list)
    },
    // !财务详情相关start
    // *9查看事前报备详情
    async handleCheckReportb(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/reportb_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('reportb')
        this.showFormMyFlow = 'showFormReportbAdd'
        this.$store.commit('process/finance/getShowForm', 'showFormReportbAdd')
      } else {
        this.get_preset_by_stage_code('reportb')
        this.showFormMyFlow = 'showFormReportbHandle'
        this.$store.commit('process/finance/getShowForm', 'showFormReportbHandle')
      }
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *14查看外部用章审批详情
    async handleCheckExtrenal(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/external_seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info

      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })

      // 处理数字
      if (this.formData.num) {
        this.formData.num = parseInt(this.formData.num)
      }
      if (this.formData.total) {
        this.formData.total = parseInt(this.formData.total)
      }

      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('external_seal')
        this.showFormMyFlow = 'showFormExtrenalAdd'
        this.$store.commit('process/admin/getShowForm', 'showFormExtrenalAdd')
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('external_seal')
        this.showFormMyFlow = 'showFormExtrenalHandle'
        this.$store.commit(
          'process/admin/getShowForm',
          'showFormExtrenalHandle'
        )
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/admin/getDraftDisable', true)
      } else {
        this.$store.commit('process/admin/getDraftDisable', false)
      }
      this.$store.commit('process/admin/getFormData', this.formData)

      console.log('conloahusdhaisudhasuid', this.formData)
      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *12查看业务详情
    async handleCheckYw(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('project_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/BProject/bproject_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addYwForm = res.datas.info
      // 处理项目
      if (this.addYwForm.project_id) {
        this.addYwForm.project_id = this.addYwForm.project_list.map((item) => {
          return item.project_id
        })
      }

      // 处理项目
      // 处理图片
      if (this.addYwForm.annex) {
        this.imgList = this.addYwForm.annex
        this.detailsImgList = this.addYwForm.annex
      }

      // 处理数字
      if (this.addYwForm.num) {
        this.addYwForm.num = parseInt(this.addYwForm.num)
      }

      // 处理驳回节点
      // 处理驳回节点
      if (this.addYwForm.stage_select) {
        this.addYwForm.stage_select.forEach((item, index) => {
          item.id = index
          item.label = ''
          item.forEach((items) => {
            item.label += items.nickname + '/'
          })
          item.label = item.label.slice(0, item.label.length - 1)
        })
      }
      console.log('业务详情', this.addYwForm)
      if (res.datas.info.is_draft == '1') {
        this.showFormMyFlow = 'showFormYwAdd'
      } else {
        this.showFormMyFlow = 'showFormYwHandle'
      }

      this.dialogVisibleFinnace = true
    },
    // *13查看合同存档
    async handleCheckHtSave(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/contract_archive_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addHtSaveForm = res.datas.info
      // 处理项目
      this.addHtSaveForm.project_id = this.addHtSaveForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addHtSaveForm.annex) {
        this.imgList = this.addHtSaveForm.annex
        this.detailsImgList = this.addHtSaveForm.annex
      }

      // 处理数字
      if (this.addHtSaveForm.num) {
        this.addHtSaveForm.num = parseInt(this.addHtSaveForm.num)
      }

      // 处理驳回节点
      if (this.addHtSaveForm.stage_select) {
        this.addHtSaveForm.stage_selectArry = []
        this.addHtSaveForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addHtSaveForm.stage_selectArry.push(a)
        })
      }

      console.log('htSave', this.addHtSaveForm)
      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('contract_archive')
        this.showFormMyFlow = 'showFormHtSaveAdd'
        this.$store.commit('process/admin/getShowForm', 'showFormHtSaveAdd')
      } else {
        this.get_preset_by_stage_code('contract_archive')
        this.showFormMyFlow = 'showFormHtSaveHandle'
        this.$store.commit('process/admin/getShowForm', 'showFormHtSaveHandle')
      }

      this.$store.commit('process/admin/getFormData', this.addHtSaveForm)

      if (this.addHtSaveForm.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addHtSaveForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },

    // *11查看合同用章审批
    async handleCheckHt(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/contract_seal_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addHtForm = res.datas.info
      // 处理项目
      this.addHtForm.project_id = this.addHtForm.project_list.map((item) => {
        return item.project_id
      })
      // 处理项目
      // 处理图片
      if (this.addHtForm.annex) {
        this.imgList = this.addHtForm.annex
        this.detailsImgList = this.addHtForm.annex
      }

      // 处理数字
      if (this.addHtForm.num) {
        this.addHtForm.num = parseInt(this.addHtForm.num)
      }

      // 处理驳回节点
      if (this.addHtForm.stage_select) {
        this.addHtForm.stage_selectArry = []
        this.addHtForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addHtForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('contract_seal')
        this.showFormMyFlow = 'showFormHtAdd'
        this.$store.commit('process/admin/getShowForm', 'showFormHtAdd')
      } else {
        this.get_preset_by_stage_code('contract_seal')
        this.showFormMyFlow = 'showFormHtHandle'
        this.$store.commit('process/admin/getShowForm', 'showFormHtHandle')
      }

      this.$store.commit('process/admin/getFormData', this.addHtForm)

      if (this.addHtForm.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.addHtForm.project_list[0].project_id)
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *10查看其他用章审批详情
    async handleCheckOther(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/chapter_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addOtherForm = res.datas.info
      // 处理项目
      this.addOtherForm.project_id = this.addOtherForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addOtherForm.annex) {
        this.imgList = this.addOtherForm.annex
        this.detailsImgList = this.addOtherForm.annex
      }

      // 处理数字
      if (this.addOtherForm.num) {
        this.addOtherForm.num = parseInt(this.addOtherForm.num)
      }

      // 处理驳回节点
      if (this.addOtherForm.stage_select) {
        this.addOtherForm.stage_selectArry = []
        this.addOtherForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addOtherForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('chapter')
        this.showFormMyFlow = 'showFormOtherAdd'
        this.$store.commit('process/admin/getShowForm', 'showFormZhuanAdd')
      } else {
        this.get_preset_by_stage_code('chapter')
        this.showFormMyFlow = 'showFormOtherHandle'
        this.$store.commit('process/admin/getShowForm', 'showFormZhuanHandle')
      }

      this.$store.commit('process/admin/getFormData', this.addOtherForm)

      if (this.addOtherForm.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addOtherForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *9查看报告用章审批详情
    async handleCheckReport(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/report_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addReportForm = res.datas.info
      // 处理项目
      this.addReportForm.project_id = this.addReportForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理数字
      if (this.addReportForm.num) {
        this.addReportForm.num = parseInt(this.addReportForm.num)
      }
      // 处理图片
      if (this.addReportForm.annex) {
        this.imgList = this.addReportForm.annex
        this.detailsImgList = this.addReportForm.annex
      }

      // 处理驳回节点
      if (this.addReportForm.stage_select) {
        this.addReportForm.stage_selectArry = []
        this.addReportForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addReportForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('report')
        this.showFormMyFlow = 'showFormReportAdd'
        this.$store.commit('process/admin/getShowForm', 'showFormClearAdd')
      } else {
        this.get_preset_by_stage_code('report')
        this.showFormMyFlow = 'showFormReportHandle'
        this.$store.commit('process/admin/getShowForm', 'showFormClearHandle')
      }

      this.$store.commit('process/admin/getFormData', this.addReportForm)

      if (this.addReportForm.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addReportForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },
    // *8查看邮寄详情
    async handleCheckSend(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Service/mail_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addSendForm = res.datas.info
      // 处理项目
      this.addSendForm.project_id = this.addSendForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addSendForm.annex) {
        this.imgList = this.addSendForm.annex
        this.detailsImgList = this.addSendForm.annex
      }

      // 处理驳回节点
      if (this.addSendForm.stage_select) {
        this.addSendForm.stage_selectArry = []
        this.addSendForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addSendForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('mail')
        this.showFormMyFlow = 'showFormSendAdd'
        this.$store.commit('process/admin/getShowForm', 'showFormAdd')
      } else {
        this.get_preset_by_stage_code('mail')
        this.showFormMyFlow = 'showFormSendHandle'
        this.$store.commit('process/admin/getShowForm', 'showFormHandle')
      }

      this.$store.commit('process/admin/getFormData', this.addSendForm)

      if (this.addSendForm.project_list.length > 0) {
        this.$store.commit('process/admin/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.addSendForm.project_list[0].project_id)
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/admin/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/admin/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/admin/getDialogVisible', true)
      }
    },

    // *7查看合同登记详情
    async handleCheckContract(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/contract_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addContractForm = res.datas.info
      // 处理项目
      this.addContractForm.project_id = this.addContractForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addContractForm.annex) {
        this.imgList = this.addContractForm.annex
        this.detailsImgList = this.addContractForm.annex
      }
      // 处理驳回节点
      if (this.addContractForm.stage_select) {
        this.addContractForm.stage_selectArry = []
        this.addContractForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addContractForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('contract')
        this.showFormMyFlow = 'showFormContractAdd'
        this.$store.commit('process/finance/getShowForm', 'showFormContractAdd')
      } else {
        this.get_preset_by_stage_code('contract')
        this.showFormMyFlow = 'showFormContractHandle'
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormContractHandle'
        )
      }

      this.$store.commit('process/finance/getFormData', this.addContractForm)

      if (this.addContractForm.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addContractForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *6查看业务结算申请详情
    async handleCheckBusiness(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/business_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addBusinessForm = res.datas.info
      // 处理项目
      this.addBusinessForm.project_id = this.addBusinessForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addBusinessForm.annex) {
        this.imgList = this.addBusinessForm.annex
        this.detailsImgList = this.addBusinessForm.annex
      }
      // 处理驳回节点
      if (this.addBusinessForm.stage_select) {
        this.addBusinessForm.stage_selectArry = []
        this.addBusinessForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addBusinessForm.stage_selectArry.push(a)
        })
      }

      console.log('业务结算申请详情', this.addBusinessForm)
      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('business')
        this.showFormMyFlow = 'showFormBusinessAdd'
        this.$store.commit('process/finance/getShowForm', 'showFormBusinessAdd')
      } else {
        this.get_preset_by_stage_code('business')
        this.showFormMyFlow = 'showFormBusinessHandle'
        this.$store.commit(
          'process/finance/getShowForm',
          'showFormBusinessHandle'
        )
      }

      this.$store.commit('process/finance/getFormData', this.addBusinessForm)

      if (this.addBusinessForm.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addBusinessForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *5查看到账记录详情
    async handleCheckArrival(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/arrival_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addArrivalForm = res.datas.info
      // 处理项目
      this.addArrivalForm.project_id = this.addArrivalForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addArrivalForm.annex) {
        this.imgList = this.addArrivalForm.annex
        this.detailsImgList = this.addArrivalForm.annex
      }

      // 处理驳回节点
      if (this.addArrivalForm.stage_select) {
        this.addArrivalForm.stage_selectArry = []
        this.addArrivalForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addArrivalForm.stage_selectArry.push(a)
        })
      }

      console.log('到账记录详情', this.addArrivalForm)
      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('arrival')
        this.showFormMyFlow = 'showFormEndAdd'
        this.$store.commit('process/finance/getShowForm', 'showFormEndAdd')
      } else {
        this.get_preset_by_stage_code('arrival')
        this.showFormMyFlow = 'showFormEndHandle'
        this.$store.commit('process/finance/getShowForm', 'showFormEndHandle')
      }

      this.$store.commit('process/finance/getFormData', this.addArrivalForm)

      if (this.addArrivalForm.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addArrivalForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *4查看项目专家费申请详情
    async handleCheckExpert(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/expert_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addExpertForm = res.datas.info
      // 处理项目
      this.addExpertForm.project_id = this.addExpertForm.project_list.map(
        (item) => {
          return item.project_id
        }
      )
      // 处理项目
      // 处理图片
      if (this.addExpertForm.annex) {
        this.imgList = this.addExpertForm.annex
        this.detailsImgList = this.addExpertForm.annex
      }

      // 处理驳回节点
      if (this.addExpertForm.stage_select) {
        this.addExpertForm.stage_selectArry = []
        this.addExpertForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addExpertForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('expert')
        this.showFormMyFlow = 'showFormZhuanAdd'
        this.$store.commit('process/finance/getShowForm', 'showFormZhuanAdd')
      } else {
        this.get_preset_by_stage_code('expert')
        this.showFormMyFlow = 'showFormZhuanHandle'
        this.$store.commit('process/finance/getShowForm', 'showFormZhuanHandle')
      }

      this.$store.commit('process/finance/getFormData', this.addExpertForm)

      if (this.addExpertForm.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addExpertForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *3查看项目结算申请详情
    async handleCheckSettlement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/settlement_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.formData = res.datas.info
      // 处理项目(多选)
      this.formData.project_id = this.formData.project_list.map((item) => {
        return item.project_id
      })
      // 处理json
      if (this.formData.money_json) {
        this.formData.money_json = JSON.parse(this.formData.money_json)
        // 处理移动端修改没有id
        this.formData.money_json.forEach((item) => {
          if (!item.id)
            item.id = parseInt((Math.random() + 1) * Math.pow(10, 6 - 1))
        })
      }
      // 处理驳回节点
      if (this.formData.stage_select) {
        this.formData.stage_selectArry = []
        this.formData.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.formData.stage_selectArry.push(a)
        })
      }
      if (res.datas.info.is_draft == '1') {
        // 获取预设审批人
        this.get_preset_by_stage_code('settlement')
        if (res.datas.info.type == '1') {
          this.$store.commit('process/finance/getShowForm', 'showFormClearAdd')
        }
        if (res.datas.info.type == '2') {
          this.$store.commit('process/finance/getShowForm', 'showFormClearAdd1')
        }
      } else {
        // 获取预设审批人
        this.get_preset_by_stage_code('settlement')

        if (res.datas.info.type == '1') {
          this.$store.commit(
            'process/finance/getShowForm',
            'showFormClearHandle'
          )
        }
        if (res.datas.info.type == '2') {
          this.$store.commit(
            'process/finance/getShowForm',
            'showFormClearHandle1'
          )
        }
      }

      // 判断草稿禁用
      if (res.datas.info.is_draft == '1' && res.datas.info.is_edit != '1') {
        this.$store.commit('process/finance/getDraftDisable', true)
      } else {
        this.$store.commit('process/finance/getDraftDisable', false)
      }

      this.$store.commit('process/finance/getFormData', this.formData)

      // 获取关联项目相关的财务行政列表
      if (this.formData.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append('project_id', this.formData.project_list[0].project_id)

        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)
          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )
          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // *2查看报销详情
    async handleCheckReimbursement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/reimbursement_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addReimbursementForm = res.datas.info
      // 处理项目
      this.addReimbursementForm.project_id =
        this.addReimbursementForm.project_list.map((item) => {
          return item.project_id
        })
      // 处理项目
      // 处理图片
      this.imgList = this.addReimbursementForm.annex
      // 处理驳回节点
      if (this.addReimbursementForm.stage_select) {
        this.addReimbursementForm.stage_selectArry = []
        this.addReimbursementForm.stage_select.forEach((item, index) => {
          let a = {
            id: '',
            label: '',
          }
          a.id = index
          item.forEach((items) => {
            a.label += items.nickname + '/'
          })
          a.label = a.label.slice(0, a.label.length - 1)
          this.addReimbursementForm.stage_selectArry.push(a)
        })
      }

      if (res.datas.info.is_draft == '1') {
        this.get_preset_by_stage_code('reimbursement')
        this.showFormMyFlow = 'showFormAdd'
        this.$store.commit('process/finance/getShowForm', 'showFormAdd')
      } else {
        this.get_preset_by_stage_code('reimbursement')
        this.showFormMyFlow = 'showFormHandle'
        this.$store.commit('process/finance/getShowForm', 'showFormHandle')
      }

      this.$store.commit(
        'process/finance/getFormData',
        this.addReimbursementForm
      )

      if (this.addReimbursementForm.project_list.length > 0) {
        this.$store.commit('process/finance/getSideBarShow', true)
        let params = new FormData()
        params.append('member_id', this.member_id)
        params.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          params.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          params.append('device', 'pc')
        }
        params.append('cache_department_id', this.cache_department_id)
        params.append('company_id', this.company_id)

        params.append(
          'project_id',
          this.addReimbursementForm.project_list[0].project_id
        )
        this.$axios({
          method: 'post',
          url: '/api/Finance/get_ffs_relevant',
          data: params,
        }).then((result) => {
          if (result.data.code != 200)
            return this.$message.error(result.data.datas.msg)

          this.$store.commit(
            'process/finance/getAboutList',
            result.data.datas.listInfo
          )

          this.$store.commit('process/finance/getDialogVisible', true)
        })
      } else {
        this.$store.commit('process/finance/getDialogVisible', true)
      }
    },
    // !财务详情相关end

    // *获取财务待办列表
    async get_finnace_coming_list() {
      this.readDisable = false
      this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
    },
    // *获取财务已办列表
    async get_finnace_wait_list() {
      this.readDisable = true
      this.$store.commit('process/myFlow/get_finnace_wait_list')
    },

    // *获取财务待阅列表
    async get_finnace_read_list() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      // param.append('search', this.searchInfo)
      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/fread_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.finnaceReadList = res.datas.listInfo
      this.finnaceReadList.forEach((item) => {
        item.project_listShow = ''
        item.project_list.forEach((items) => {
          item.project_listShow += items + '  '
        })
      })
      this.Total = parseInt(res.datas.count)
      console.log('待阅财务列表', this.finnaceReadList)
    },
    // *获取财务已阅列表
    async get_finnace_read_wait_list() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      // param.append('search', this.searchInfo)
      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/arfread_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.finnaceReadList = res.datas.listInfo
      this.finnaceReadList.forEach((item) => {
        item.project_listShow = ''
        item.project_list.forEach((items) => {
          item.project_listShow += items + '  '
        })
      })
      this.Total = parseInt(res.datas.count)
      console.log('已经财务列表', this.finnaceReadList)
    },

    goProjectDetails(item) {
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          isEdit: '1',
          fromIndex: '1',
        },
      })
    },
    goProjectDetailsBack(item) {
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          isEdit: '1',
          from: 'myFlow',
          fromIndex: '1',
        },
      })
    },
    // 通过成员申请点击
    handlePassUser(id) {
      this.editUserId = id
      this.passUserDialogVisible = true
    },
    // *通过成员申请提交
    async handlePassUserSubmit() {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('apply_id', this.editUserId)
      param.append('status', '1')

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      this.passUserDialogVisible = false
      this.getmemberlist()
      this.getNumerData()
    },
    // 驳回成员申请点击
    handleRejectUser(id) {
      this.editUserId = id
      this.rejectUserDialogVisible = true
    },
    // *驳回成员申请提交
    async handleRejectUserSubmit() {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('apply_id', this.editUserId)
      param.append('status', '-1')

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      this.rejectUserDialogVisible = false
      this.getmemberlist()
      this.getNumerData()
    },
    // *项目阅读
    async handleProjectRead(item) {
      // return console.log('item', item)
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('read_id', item.id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/set_read',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.getread_list()
      this.getNumerData()
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          project_name: item.project_name,
          project_code: item.project_code,
          company_name: item.company_name,
          isEdit: '1',
          fromIndex: '1',
        },
      })
    },
    // 已阅查看
    handleProjectReaded(item) {
      this.$router.push({
        path: '/project/details/task',
        query: {
          project_id: item.project_id,
          project_status: item.project_status,
          project_name: item.project_name,
          project_code: item.project_code,
          company_name: item.company_name,
          isEdit: '1',
          fromIndex: '1',
        },
      })
    },
    // *项目通过驳回
    async handlePass(item) {
      this.editPassId = item.id
      if (this.clientActive == '3') {
        this.finance_id = item.finance_id
        this.stage_code = item.stage_code
      }
      this.passDialogVisible = true
    },
    async handleReject(item) {
      this.editPassId = item.id
      this.rejectDialogVisible = true
    },

    // *通过提交
    async passSubmit() {
      if (this.clientActive == '1') {
        // *项目审批提交(通过)
        this.disableLimit = true
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('read_id', this.editPassId)
        param.append('approval_status', '1')
        param.append('remark', this.passReason)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/project_approval',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.passDialogVisible = false
        this.getupcoming_list()
        this.getNumerData()
      }
      if (this.clientActive == '3') {
        this.disableLimit = true
        // *财务审批提交(通过)
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('read_id', this.editPassId)

        // param.append('finance_id', this.finance_id)
        param.append('stage_code', this.stage_code)

        param.append('approval_status', '1')
        param.append('remark', this.passReason)

        param.append('sign_pic', this.sign_pic)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/finance_approval',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.passDialogVisible = false
        this.get_finnace_coming_list()
        this.getNumerData()
      }
    },
    // *审批驳回提交
    async rejectSubmit() {
      if (this.clientActive == '1') {
        this.disableLimit = true
        // *项目审批(驳回)
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('read_id', this.editPassId)
        param.append('approval_status', '-1')
        param.append('remark', this.rejectReason)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/project_approval',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.rejectDialogVisible = false
        this.getupcoming_list()
        this.getNumerData()
      }
      if (this.clientActive == '3') {
        this.disableLimit = true
        // *财务审批(驳回)
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('read_id', this.editPassId)

        param.append('finance_id', this.finance_id)
        param.append('stage_code', this.stage_code)

        param.append('approval_status', '-1')
        param.append('remark', this.rejectReason)
        param.append('sign_pic', this.sign_pic)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/finance_approval',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.rejectDialogVisible = false
        this.get_finnace_coming_list()
        this.getNumerData()
      }
    },
    // *获取新成员申请列表
    async getmemberlist() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      // param.append('search', this.searchInfo)fg
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member_applylist',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.memberList = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('新成员申请列表', this.memberList)
    },
    // *获取待阅项目列表
    async getread_list() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      // param.append('search', this.searchInfo)
      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/read_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.readList = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('待阅项目列表', this.readList)
    },
    // *获取已阅项目列表
    async getread_list_wait() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      // param.append('search', this.searchInfo)
      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/arread_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.readList = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('待阅项目列表', this.readList)
    },

    // *获取待办项目列表
    async getupcoming_list() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/upcoming_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.upcomingList = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('待办项目列表', this.upcomingList)
    },
    // *获取已办项目列表
    async getupWait_list() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      // param.append('project_status', this.project_status)
      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)
      param.append('start_time', this.searchDate1)
      param.append('end_time', this.searchDate2)
      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/arupcoming_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.upcomingList = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      console.log('已办项目列表', this.upcomingList)
    },
    // *获取首页信息
    async getNumerData() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)
      const { data: res } = await this.$http({
        method: 'post',
        url: '/api/Management/msg_upcoming',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      // this.numData = res.datas
      if (res.datas.list[0] || res.datas.list[0] == 0) {
        this.waitnumber1 = parseInt(res.datas.list[0])
      }
      if (res.datas.list[1] || res.datas.list[1] == 0) {
        this.waitnumber2 = parseInt(res.datas.list[1])
      }
      if (res.datas.list[2] || res.datas.list[2] == 0) {
        this.waitnumber3 = parseInt(res.datas.list[2])
      }
      if (res.datas.list[3] || res.datas.list[3] == 0) {
        this.waitnumber4 = parseInt(res.datas.list[3])
      }
      if (res.datas.list[4] || res.datas.list[4] == 0) {
        this.waitnumber5 = parseInt(res.datas.list[4])
      }
    },
    // *获取项目列表
    async getProjectList() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectList = res.datas.listInfo
      console.log('项目列表(用于表单选项)', this.financeIndexData)
    },
    // *获取项目列表
    async getProjectList1() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/fsimple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectList1 = res.datas.listInfo
      console.log('项目列表(用于表单选项)', this.financeIndexData)
    },

    handleClick(tab, event) {
      this.searchInfo1 = ''
      this.$store.commit('process/myFlow/setSearchInfo', '')
      this.searchUserId = ''
      this.$store.commit('process/myFlow/setSearchPeople', '')
      this.$store.commit('process/myFlow/setSearchStagecode', '')
      this.searchDate2 = ''
      this.searchDate1 = ''
      this.searchStage_code = ''
      if (tab.name == '1') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '50px'
        })
        this.currentPage = 1
        this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', 1)
        if (this.projectDoWait) {
          this.getupcoming_list()
        } else {
          this.getupWait_list()
        }
      } else if (tab.name == '2') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '50px'
        })
        this.currentPage = 1
        this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', 1)
        // this.getread_list()
        if (this.projectReadWait) {
          this.getread_list()
        } else {
          this.getread_list_wait()
        }
      } else if (tab.name == '3') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '50px'
        })
        this.currentPage = 1
        this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', 1)
        // this.get_finnace_coming_list()
        if (this.finaceDoWait) {
          this.get_finnace_coming_list()
        } else {
          this.get_finnace_wait_list()
        }
      } else if (tab.name == '4') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '50px'
        })
        this.currentPage = 1
        this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', 1)
        // this.get_finnace_read_list()
        if (this.finaceReadWait) {
          this.get_finnace_read_list()
        } else {
          this.get_finnace_read_wait_list()
        }
      } else if (tab.name == '5') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '60px'
        })
        this.currentPage = 1
        this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', 1)
        this.getmemberlist()
      }
    },

    // 图片放大缩小

    // 下载图片
    DownImg() {
      var a = document.createElement('a')
      a.download = this.imgList[this.checkOutImgIndex]
      // 设置图片地址
      a.href = this.imgList[this.checkOutImgIndex]
      a.click()
    },
    goTop() {
      this.checkOutImgIndex = parseInt(this.checkOutImgIndex) - 1
      console.log(this.checkOutImgIndex)
    },
    goBottom() {
      this.checkOutImgIndex = parseInt(this.checkOutImgIndex) + 1
      console.log(this.checkOutImgIndex)
    },
    // handleCheckOutImgItem(val) {
    //   this.checkOutImgIndex = this.imgList.findIndex((item) => item === val)
    //   if (this.checkOutImgIndex != -1) {
    //     this.imgDia = true
    //   }
    // },
    handleCheckOutImgItem(val, index) {
      // const $viewer = this.$viewerApi({
      //   images: this.sourceImageURLs,
      // })
      // 或者你可以单独引入api然后执行它
      console.log('imgList', this.imgList)
      const $viewer = viewerApi({
        options: {
          toolbar: true,
          // url: 'data-source',
          initialViewIndex: index,
          tooltip: true,
          fullscreen: true,
          keyboard: true,
          zIndex: 9999,
        },
        images: this.imgList,
      })
      return
      this.checkOutImgIndex = this.imgList.findIndex((item) => item === val)
      if (this.checkOutImgIndex != -1) {
        this.imgDia = true
      }
    },
    handleSizeImgChange(val) {
      if (val == 'add') {
        // console.log(parseInt(this.imgSize.split('%')[0]))
        // parseInt(this.imgSize.split('%')[0]) += 20
        const a = parseInt(this.imgSize.split('%')[0]) + 20
        this.imgSize = a + '%'
      } else if (val == 'down') {
        const a = parseInt(this.imgSize.split('%')[0]) - 20
        this.imgSize = a + '%'
      }
      console.log('this.imgSize', this.imgSize)
    },
    // 图片放大缩小

    imghandleClose(done) {
      this.imgDia = false
    },
    imghandleClosed() {
      this.imgSize = '100%'
    },
    handlePassClose(done) {
      this.passDialogVisible = false
    },
    handlePassClosed() {
      this.passReason = ''
      this.finance_id = ''
      this.stage_code = ''
      this.sign_pic = ''
    },
    handleRejectClose(done) {
      this.rejectDialogVisible = false
    },
    handleRejectClosed() {
      this.rejectReason = ''
      this.finance_id = ''
      this.stage_code = ''
      this.sign_pic = ''
    },
    handleUserPassClose(done) {
      this.passUserDialogVisible = false
    },
    handleUserPassClosed() {
      this.editUserId = ''
    },
    handleUserRejectClose(done) {
      this.rejectUserDialogVisible = false
    },
    handleUserRejectClosed() {
      this.editUserId = ''
    },
    handleCloseFinnace() {
      this.dialogVisibleFinnace = false
    },
    handleClosedFinnace() {
      if (!this.finaceDoWait || !this.finaceReadWait) {
      } else {
        this.readDisable = false
      }
      this.approvalRemark = ''
      this.detailsImgList = []
      this.imgList = []
      this.k_code = ''
    },

    handleCloseFinnaceAdmin(done) {
      this.$store.commit('process/admin/getDialogVisible', false)
    },
    handleClosedFinnaceAdmin() {
      this.$store.commit('process/admin/emptyFormData')
      this.$store.commit('process/admin/getDraftDisable', false)
      this.$store.commit('process/admin/getSideBarShow', false)

      this.$store.commit('process/admin/getContainerType', '0')

      this.comReload = false
      setTimeout(() => {
        this.comReload = true
      }, 1)
    },

    handleCloseFinnaceFinance(done) {
      this.$store.commit('process/finance/getDialogVisible', false)
    },
    handleClosedFinnaceFinance() {
      this.$store.commit('process/finance/emptyFormData')
      this.$store.commit('process/finance/getDraftDisable', false)
      this.$store.commit('process/finance/getSideBarShow', false)

      this.$store.commit('process/finance/getContainerType', '0')

      this.comReload = false
      setTimeout(() => {
        this.comReload = true
      }, 1)
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val
      this.$store.commit('process/myFlow/finnaceUpcomingPageSize', val)
      if (this.clientActive == '1') {
        this.getupcoming_list()
      }
      if (this.clientActive == '2') {
        this.getread_list()
      }
      if (this.clientActive == '3') {
        this.get_finnace_coming_list()
      }
      if (this.clientActive == '4') {
        this.get_finnace_read_list()
      }
      if (this.clientActive == '5') {
        this.getmemberlist()
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.$store.commit('process/myFlow/setFinnaceUpcomingCurrentPage', val)
      if (this.clientActive == '1') {
        // this.getupcoming_list()
        if (this.projectDoWait) {
          this.getupcoming_list()
        } else {
          this.getupWait_list()
        }
      }
      if (this.clientActive == '2') {
        // this.getread_list()
        if (this.projectReadWait) {
          this.getread_list()
        } else {
          this.getread_list_wait()
        }
      }
      if (this.clientActive == '3') {
        // this.get_finnace_coming_list()
        if (this.finaceDoWait) {
          this.get_finnace_coming_list()
        } else {
          this.get_finnace_wait_list()
        }
      }
      if (this.clientActive == '4') {
        // this.get_finnace_read_list()
        if (this.finaceReadWait) {
          this.get_finnace_read_list()
        } else {
          this.get_finnace_read_wait_list()
        }
      }
      if (this.clientActive == '5') {
        this.getmemberlist()
      }
    },
  },
  activated() {
    this.getupcoming_list()
    this.getNumerData()
    // console.log('activatedactivatedactivatedactivatedactivated')
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    // this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getNumerData()
    this.getProjectList()
    this.getProjectList1()
    this.getupcoming_list()
  },
}
</script>
<style lang="less" scoped>
@import url(./finance.scss);
@import url(./myFlow.scss);
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;
    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
</style>
